/**
 * @generated SignedSource<<01ec2e05dead0893f82109dd8a42783c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TravelDocumentsListRow_document$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity">;
  readonly " $fragmentType": "TravelDocumentsListRow_document";
};
export type TravelDocumentsListRow_document$key = {
  readonly " $data"?: TravelDocumentsListRow_document$data;
  readonly " $fragmentSpreads": FragmentRefs<"TravelDocumentsListRow_document">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TravelDocumentsListRow_document",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    }
  ],
  "type": "TravelDocument",
  "abstractKey": null
};

(node as any).hash = "0ccaec07b99c63f97055da0a748fccc0";

export default node;
